import actState from './state';
import { IActGetters } from '@/models/act/store/state.interface';

const actGetters: IActGetters = {
	actAccessEntries: () => {
		return actState.actAccessEntries;
	},
	actAvailableDashboards: () => {
		return actState.actAvailableDashboards;
	},
	actAvailableDashboardsAsOptions: () => {
		return actState.actAvailableDashboards.map((dashboard) => ({
			label: dashboard.productName,
			value: dashboard.productNumber
		}));
	},
	actDashboardsToAdd: () => {
		return actState.actDashboardsToAdd;
	},
	actSameDateForDashboards: () => {
		return actState.actSameDateForDashboards;
	},
	actUsersToAdd: () => {
		return actState.actUsersToAdd;
	},
	modalActAccessState: () => {
		return actState.modalActAccessState;
	},
	selectedActFilterOption: () => {
		return actState.selectedActFilterOption;
	},
	selectedActInvoiceNumber: () => {
		return actState.selectedActInvoiceNumber;
	}
};

export default actGetters;
